import LocalizedStrings from 'localized-strings';

import { AccountClosureReason } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    subtitle: 'You can choose multiple reasons.',
    title: 'I am satisfied with Shine but…',
    [AccountClosureReason.SatisfiedMissingBankingService]:
      'I need a banking service that you do not offer',
    [AccountClosureReason.SatisfiedMissingFeature]:
      'I need a feature that Shine doesn’t offer',
    [AccountClosureReason.SatisfiedNoActivityOrTooFewActivityForNow]:
      'I don’t use my account enough',
    [AccountClosureReason.SatisfiedPricingIssue]:
      'I find the service too expensive',
    [AccountClosureReason.SatisfiedOther]: 'Other',
    [AccountClosureReason.SatisfiedTechnicalIssue]:
      'I’m experiencing too many technical problems',
  },
  fr: {
    subtitle: 'Vous pouvez sélectionner plusieurs raisons.',
    title: 'Je suis satisfait·e de Shine mais…',
    [AccountClosureReason.SatisfiedMissingBankingService]:
      'J’ai besoin d’un service bancaire qui n’est pas proposé',
    [AccountClosureReason.SatisfiedMissingFeature]:
      'J’ai besoin d’une fonctionnalité qui n’est pas proposée',
    [AccountClosureReason.SatisfiedNoActivityOrTooFewActivityForNow]:
      'Je n’utilise pas assez mon compte',
    [AccountClosureReason.SatisfiedPricingIssue]:
      'Je trouve le service trop cher',
    [AccountClosureReason.SatisfiedOther]: 'Autre',
    [AccountClosureReason.SatisfiedTechnicalIssue]:
      'Je rencontre trop de problèmes techniques',
  },
});

export default locales;
